import React, { Component } from 'react'
import Axios from 'axios'
import Loader from '../Loader'
import ProgressBar from '../ProgressBar/ProgressBar'
import { Urls } from '../../Urls'
import { constants } from "../../constants";
import { toast, ToastContainer } from 'react-toastify'
import { logActivity } from '../Utilities'
var isEmpty = false
var raw_input = []
class ManualLocation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            manualEntries: [],
            search: [],
            loader: false,
            locAuto: [],
            current_row: 0
        }
    }
    componentDidMount() {
        // logActivity([
        //     {
        //         'screen': 'Manual Location Cleaning',
        //         'module': 'Location Cleaning',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Manual Input"
        document.getElementById("header").style.opacity = "0.5"
        const body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "fetch",
            "input": []
        }

        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.location.manual, body)
                .then(response => {
                    console.log(response)
                    this.setState({
                        manualEntries: response.data.data,
                        search: response.data.search,
                        loader: false
                    }, () => { if (this.state.manualEntries.length === 0) { this.skip() } })
                    var i = 0
                    for (i = 0; i < this.state.manualEntries.length; i++) {
                        raw_input.push({ "manual": "" })
                    }
                    if (this.state.manualEntries.length === 0) {
                        isEmpty = true
                    }
                    document.getElementById("header").style.opacity = "1"
                })
                .catch(error => {
                    console.log(error)
                })
        })
    }
    skip = () => {
        var body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "location"
        }
        Axios.post(Urls.master, body)
            .then(response => {
                // console.log(response)
                this.setState({ loader: false })
                document.getElementById("header").style.opacity = "1"
                sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                this.props.history.push({ pathname: "/directMatchVendor" })
            })
            .catch(error => {
                console.log(error)
                toast.error('Error while rpocessing your request')
                this.setState({ loader: false })
                document.getElementById('header').style.opacity = 1
            })
    }
    manualHandler = (event) => {
        const rowIndex = parseInt(event.target.name)
        const userInputValue = event.target.value
        // raw_input[rowIndex] = { "manual": userInputValue }
        for(let i = 0; i < raw_input.length; i++){
            if(i == rowIndex){
                raw_input[i] = {
                    'manual': userInputValue
                }
            }
        }
        console.clear()
        console.log(rowIndex)
        console.log(userInputValue)
        this.setState({ current_row: parseInt(event.target.name) })
        if (event.target.value !== "" && ((event.target.value.length >= 3))) {
            Axios.get(`${Urls.autocomplete}?country=INDIA&limit=10&suggest=${event.target.value}&searchFields=locations`)
                .then(res => {
                    this.setState({
                        locAuto: res.data.value
                    })
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }

    submitHandler = (event) => {
        event.preventDefault()
        if (!isEmpty) {
            var emptyRows = []
            for (let i = 0; i < raw_input.length; i++) {
                if (new RegExp(constants.regex_patterns.emptyString).test(raw_input[i]["manual"])) {
                    if (document.getElementById(`raw_input_${i}`)) {
                        document.getElementById(`raw_input_${i}`).style.border = '1px solid red'
                    }
                    // alert
                    emptyRows.push(raw_input[i])
                }
                else {
                    if (!new RegExp(constants.regex_patterns.location).test(raw_input[i]["manual"])) {
                        if (document.getElementById(`raw_input_${i}`)) {
                            document.getElementById(`raw_input_${i}`).style.border = '1px solid red'
                        }
                        // emptyRows.push(raw_input[i])
                    }
                    else {
                        if (document.getElementById(`raw_input_${i}`)) {
                            document.getElementById(`raw_input_${i}`).style.border = '1px solid royalblue'
                        }
                    }
                }
            }
            // console.log(emptyRows)
            if (emptyRows.length === 0) {
                // logActivity([
                //     {
                //         'screen': 'Manual Location Cleaning',
                //         'module': 'Location Cleaning',
                //         'user_activity': 'data submission',
                //         'timestamp': new Date().toISOString()
                //     }
                // ])
                const body = {
                    'dataset_id': localStorage.getItem('dataset_id'),
                    'key': 'dump',
                    'input': raw_input
                }
                console.log(body)
                document.getElementById('header').style.opacity = 0.5
                this.setState({
                    loader: true
                }, () => {
                    Axios.post(Urls.location.manual, body)
                        .then(response => {
                            console.log(response)

                            var body = {
                                "dataset_id": localStorage.getItem("dataset_id"),
                                "key": "location"
                            }
                            Axios.post(Urls.master, body)
                                .then(response => {
                                    console.log(response)
                                    this.setState({ loader: false })
                                    document.getElementById("header").style.opacity = "1"
                                    sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                                    this.props.history.push({ pathname: "/directMatchVendor" })
                                })
                                .catch(error => {
                                    console.log(error)
                                    toast.error('Error while rpocessing your request')
                                    this.setState({ loader: false })
                                    document.getElementById('header').style.opacity = 1
                                })
                        })
                        .catch(error => {
                            console.log(error)
                            toast.error('Error while rpocessing your request')
                            this.setState({ loader: false })
                            document.getElementById('header').style.opacity = 1
                        })
                })
            }
            else {
                alert('Please enter location. Eg. City, District(optional), State')
                console.log(emptyRows)
            }
        }
        else {
            const body = {
                'dataset_id': localStorage.getItem('dataset_id'),
                'key': 'dump',
                'input': this.state.manualEntries
            }
            this.setState({
                loader: true
            }, () => {
                Axios.post(Urls.location.manual, body)
                    .then(res => {
                        var body = {
                            "dataset_id": localStorage.getItem("dataset_id"),
                            "key": "location"
                        }
                        Axios.post(Urls.master, body)
                            .then(response => {
                                console.log(response)
                                this.setState({ loader: false })
                                document.getElementById("header").style.opacity = "1"
                                this.props.history.push({ pathname: "/directMatchVendor" })
                            })
                            .catch(error => {
                                toast.error('Error while rpocessing your request')
                                this.setState({ loader: false })
                                document.getElementById('header').style.opacity = 1
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        console.log(error)
                        toast.error('Error while rpocessing your request')
                        this.setState({ loader: false })
                        document.getElementById('header').style.opacity = 1
                    })
            })
        }
    }

    // navigation toggles
    goBack = () => {
        this.props.history.push({
            pathname: "/spellCorrectionLocation"
        })
    }
    render() {
        var locations = this.state.manualEntries
        var searchItems = this.state.locAuto
        var c_row = this.state.current_row
        return (
            <div id="header">
                <ToastContainer />
                <Loader isLoading={this.state.loader} />
                <div className="container">
                    <div >
                        <div className="row" align="center">
                            <div className="col-1">
                                <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table border="1" id="dc_table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Raw Location</th>
                                            <th>Raw State</th>
                                            <th>User Input</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            locations.map((location, i) =>
                                                <tr>
                                                    <td> {i + 1} </td>
                                                    <td> {location['Raw Location']} </td>
                                                    <td> {location['Raw State']} </td>
                                                    <td>
                                                        <input list="auto" name={i} key={`raw_input_${i}`} className="form-control" style={{ "border": "1px solid royalblue" }} id={`raw_input_${i}`} type="text" placeholder="City, District(optional), State" onChange={this.manualHandler} />
                                                        {
                                                            (c_row === i) ? (
                                                                <datalist id="auto">
                                                                    {
                                                                        (searchItems.length === 0 || searchItems === undefined) ? (<option>No location found!</option>) : (
                                                                            searchItems.map(item => <option value={`${item.location.location}, ${item.location.district}, ${item.location.state}, ${item.location.lat}, ${item.location.lon}`}> {`${item.location.location}, ${item.location.district}, ${item.location.state}`} </option>
                                                                            ))
                                                                    }
                                                                </datalist>
                                                            ) : (null)
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-1 navButtonsCircleRight">
                            <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="54%" />
                </div>
            </div>
        )
    }
}

export default ManualLocation
